import useComplaintFilter from './useComplaintFilter'

export default useComplaintFilter
